module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
  return _vm._c('doc-section', {
    attrs: {
      "id": "datepicker",
      "name": "Datepicker"
    }
  }, [_vm._c('div', {
    staticClass: "bs-example"
  }, [_vm._c('p', [_vm._c('pre', [_vm._v("Selected date is: " + _vm._s(_vm.dateString))])]), _vm._v(" "), _vm._c('datepicker', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.date),
      expression: "date"
    }],
    ref: "dp",
    attrs: {
      "disabled-days-of-week": _vm.disabled,
      "format": _vm.format,
      "clear-button": _vm.clear,
      "placeholder": _vm.placeholder,
      "width": "370px"
    },
    domProps: {
      "value": (_vm.date)
    },
    on: {
      "input": function($event) {
        _vm.date = $event
      }
    }
  }), _vm._v(" "), _vm._c('h4', [_vm._v("Disabled days of week")]), _vm._v(" "), _vm._c('v-select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.disabled),
      expression: "disabled"
    }],
    attrs: {
      "multiple": "",
      "options": [0, 1, 2, 3, 4, 5, 6]
    },
    domProps: {
      "value": (_vm.disabled)
    },
    on: {
      "input": function($event) {
        _vm.disabled = $event
      }
    }
  }), _vm._v(" "), _vm._c('h4', [_vm._v("Format")]), _vm._v(" "), _vm._c('v-select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.format),
      expression: "format"
    }],
    attrs: {
      "options": _vm.formats
    },
    domProps: {
      "value": (_vm.format)
    },
    on: {
      "input": function($event) {
        _vm.format = $event
      }
    }
  }), _vm._v(" "), _vm._c('h4', [_vm._v("Reset button")]), _vm._v(" "), _vm._c('checkbox', {
    attrs: {
      "value": _vm.clear,
      "type": "primary"
    },
    on: {
      "checked": function($event) {
        _vm.clear = arguments[0]
      }
    }
  }, [_vm._v("toggle clear button")])], 1), _vm._v(" "), _vm._c('doc-code', {
    attrs: {
      "language": "markup"
    }
  }, [_vm._v("\n    <datepicker v-model=\"value\" :disabled-days-of-Week=\"disabled\" :format=\"format\" :clear-button=\"clear\" :placeholder=\"placeholder\"></datepicker>\n  ")]), _vm._v(" "), _vm._c('doc-table', [_vm._c('div', [_vm._c('p', [_vm._v("clear-button")]), _vm._v(" "), _vm._c('p', [_vm._c('code', [_vm._v("Boolean")])]), _vm._v(" "), _vm._c('p', [_vm._v("false")]), _vm._v(" "), _vm._c('p', [_vm._v("If "), _vm._c('strong', [_vm._v("true")]), _vm._v(" shows an × shaped button to clear the selected date.\n        Usefull in forms where date entry is optional.")])]), _vm._v(" "), _vm._c('div', [_vm._c('p', [_vm._v("disabled-days-of-week")]), _vm._v(" "), _vm._c('p', [_vm._c('code', [_vm._v("Array")])]), _vm._v(" "), _vm._c('p'), _vm._v(" "), _vm._c('p', [_vm._v("Days of the week that should be disabled. Values are 0 (Sunday) to 6 (Saturday).\n         Multiple values should be comma-separated.")])]), _vm._v(" "), _vm._c('div', [_vm._c('p', [_vm._v("format")]), _vm._v(" "), _vm._c('p', [_vm._c('code', [_vm._v("String")])]), _vm._v(" "), _vm._c('p', [_vm._c('code', [_vm._v("MMMM/dd/yyyy")])]), _vm._v(" "), _vm._c('p', [_vm._v("The date format, combination of d, dd, M, MM, MMM, MMMM, yyyy.")])]), _vm._v(" "), _vm._c('div', [_vm._c('p', [_vm._v("placeholder")]), _vm._v(" "), _vm._c('p', [_vm._c('code', [_vm._v("String")])]), _vm._v(" "), _vm._c('p'), _vm._v(" "), _vm._c('p', [_vm._v("Placeholder to put on the input field when no date (null or empty) is set")])]), _vm._v(" "), _vm._c('div', [_vm._c('p', [_vm._v("value")]), _vm._v(" "), _vm._c('p', [_vm._c('code', [_vm._v("String")])]), _vm._v(" "), _vm._c('p'), _vm._v(" "), _vm._c('p', [_vm._v("Value of the input DOM")])]), _vm._v(" "), _vm._c('div', [_vm._c('p', [_vm._v("width")]), _vm._v(" "), _vm._c('p', [_vm._c('code', [_vm._v("String")])]), _vm._v(" "), _vm._c('p'), _vm._v(" "), _vm._c('p', [_vm._v("Width of the input DOM")])]), _vm._v(" "), _vm._c('div', [_vm._c('p', [_vm._v("icons-font")]), _vm._v(" "), _vm._c('p', [_vm._c('code', [_vm._v("String")])]), _vm._v(" "), _vm._c('p', [_vm._c('code', [_vm._v("glyphicon")])]), _vm._v(" "), _vm._c('p', [_vm._v("The icon font used for arrows. Can be 'glyphicon' or 'fa' (Font Awesome)")])])]), _vm._v(" "), _vm._c('doc-table', {
    attrs: {
      "type": "Events"
    }
  }, [_vm._c('div', [_vm._c('p', [_vm._v("input")]), _vm._v(" "), _vm._c('p', [_vm._v("("), _vm._c('code', [_vm._v("value:string")]), _vm._v(")")]), _vm._v(" "), _vm._c('p', [_vm._v("Return the selected value.")])])])], 1)
},staticRenderFns: []}
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-4158485e", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-4158485e!./~/vue-loader/lib/selector.js?type=template&index=0!./docs/example/datepickerDocs.vue
// module id = 174
// module chunks = 0